import styles from './carousel.module.scss';
import { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { virtualize } from 'react-swipeable-views-utils';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import ImageViewer from 'components/common/ImageViewer/ImageViewer';
import CustomImageViewer from 'components/common/CustomImageViewer';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);

export default function Carousel(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const images = props.images.slice(0, 4);
  const maxSteps = images.length;
  const isGrayScale = props.grayscale;
  const { space } = props;

  function slideRenderer(params) {
    const { key } = params;
    return (
      <div key={'carousel-img-' + key}>
        <Box
          data-testid="CarouselBox"
          sx={{
            width: 317,
            minHeight: 320,
            height: '100%',
            display: 'block',
            filter: isGrayScale ? 'grayscale(100%)' : '',
          }}>
          <ImageViewer
            handleExpandClick={handleExpandClick}
            currentImage={activeStep}
            images={images}
            space={space}
          />
        </Box>
      </div>
    );
  }

  const handleExpandClick = () => {
    setIsOpen(true);
  };

  const handleImageClose = () => {
    setIsOpen(false);
  };

  const handleSwip = (index) => {
    if (index === maxSteps) setActiveStep(0);
    else if (index < 0) setActiveStep(maxSteps - 1);
    else setActiveStep(index);
  };
  const handleNext = () => handleSwip(activeStep + 1);
  const handleBack = () => handleSwip(activeStep - 1);

  return (
    <div className={styles.container}>
      <VirtualizeSwipeableViews
        data-testid="VirtualizeSwipeableViews"
        enableMouseEvents
        index={activeStep}
        onChangeIndex={handleSwip}
        slideRenderer={slideRenderer}></VirtualizeSwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{
          width: 300,
          height: 10,
        }}
        nextButton={
          <Button
            data-testid="CarouselNextBtn"
            size="small"
            sx={{
              top: -50,
              left: 10,
              minWidth: 32,
              height: 32,
              background: 'white',
              '&:hover': {
                color: 'red',
                backgroundColor: 'white',
              },
            }}
            onClick={handleNext}>
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button
            data-testid="CarouselPrevBtn"
            sx={{
              top: -50,
              right: 10,
              minWidth: 32,
              height: 32,
              background: 'white',
              '&:hover': {
                color: 'red',
                backgroundColor: 'white',
              },
            }}
            onClick={handleBack}>
            <KeyboardArrowLeft />
          </Button>
        }
      />
      {isOpen && (
        <CustomImageViewer
          handleNext={handleNext}
          handleBack={handleBack}
          handleSumbnailClick={setActiveStep}
          space={space}
          currentImage={props.images[activeStep]}
          images={props.images.map((image) => ({ src: image }))}
          isOpen={isOpen}
          onClose={handleImageClose}
        />
      )}
    </div>
  );
}
